import { buildParams } from 'app/utils/pagination';
import { replaceClientImage } from 'app/utils/string';
import { serverRequest } from 'app/requests/serverRequest';
import { apiRequest, ResultAPI } from 'app/requests/apiRequest';

export const getTests = async (params, token: string = '') => {
  const paramsUrl = buildParams(params);
  const path = `/api/tests${paramsUrl}`;
  const tests = await serverRequest(path, 'get', token);

  return tests?.data;
};

export const getByTestSlug = async (slug: string, params = {}) => {
  const paramsUrl = buildParams(params);
  const result = await apiRequest(`/api/tests/${slug}${paramsUrl}`, 'get') as ResultAPI;
  const test = result.data;
  if (test.passages) {
    test.passages = test.passages.map(passage => {
      passage.content = replaceClientImage(passage.content, test.title);
      return passage;
    });
  }
  return test;
};

export const getPassageByUserId = async (testId: number, userId: number) => {
  const passages = await apiRequest(`/api/tests/${testId}/${userId}/passages`, 'get') as ResultAPI;
  return passages.data;
};

export const storePassagesForUser = async (data) => {
  return await apiRequest(`/api/tests/passages/store`, 'post', data);
};

export const ieltsSpeakStore = async (data) => {
  return await apiRequest(`/api/tests/ielts-speak/store`, 'post', data);
};

export const ieltsSpeakGet = async (id: number) => {
  return await apiRequest(`/api/tests/ielts-speak/${id}`, 'get');
};

export const ieltsSpeakDelete = async (id: number) => {
  return await apiRequest(`/api/tests/ielts-speak/${id}`, 'delete');
};
